 
import { useEventById } from 'core/api/events';
import { DisabledField, ModalType } from 'core/useCases/modal/types';
import { useModalStore } from 'stores/modal';
import Edit from 'images/icons/Edit.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type UpdateEventButtonProps = {
    eventId: string;
};

const UpdateEventButton: FC<UpdateEventButtonProps> = ({ eventId }) => {
    const { t } = useTranslation();
    const openModal = useModalStore((s) => s.openModal);
    const event = useEventById(eventId).data;

    const openUpdatingModal = () => {
        openModal({
            defaultValues: event,
            disabledFields: [DisabledField.ContactId, DisabledField.ApplicationId],
            title: t('activities.update-this-interview'),
            type: ModalType.Event,
        });
    };

    return (
        <button onClick={() => openUpdatingModal()} type="button">
            <Edit />
        </button>
    );
};

export default UpdateEventButton;
